export default "__VITE_ASSET__DzvCObPP__"